// Constantes compartilhadas do módulo Radar / Inteligência Comercial.
// Fonte de verdade de rótulos e pesos do HOP Radar Score (espelhados na edge function radar-admin).

export const TIPO_LABELS: Record<string, string> = {
  nova_sede: 'Nova sede',
  expansao: 'Expansão',
  reforma: 'Reforma',
  obra_privada: 'Obra privada',
  obra_publica: 'Obra pública',
  obra_nao_identificada: 'Obra — natureza não identificada',
  hospital_saude: 'Hospital / Saúde',
  clinica: 'Clínica',
  educacao: 'Educação',
  hotelaria: 'Hotelaria',
  industria: 'Indústria',
  escritorio: 'Escritório',
  predio_corporativo: 'Prédio corporativo',
  varejo_rede: 'Varejo / Rede',
  coworking: 'Coworking',
  retrofit: 'Retrofit',
  licitacao_sinal: 'Licitação (sinal)',
  relacionamento: 'Relacionamento',
  indicacao: 'Indicação',
  outro: 'Outro',
};

export const SOLUCOES_LABELS: Record<string, string> = {
  mobiliario_corporativo: 'Mobiliário corporativo',
  cadeiras: 'Cadeiras',
  estacoes_trabalho: 'Estações de trabalho',
  diretoria: 'Diretoria',
  reuniao: 'Reunião',
  recepcao: 'Recepção',
  auditorio: 'Auditório',
  divisorias: 'Divisórias',
  acustica: 'Acústica',
  cabine_acustica: 'Cabine acústica',
  carpete: 'Carpete',
  persianas: 'Persianas',
  pisos: 'Pisos',
  marcenaria: 'Marcenaria',
  tecnologia: 'Tecnologia',
  mobiliario_escolar: 'Mobiliário escolar',
  turnkey: 'Turnkey',
  outro: 'Outro',
};

export const STATUS_LABELS: Record<string, string> = {
  detectada: 'Detectada',
  triagem: 'Em triagem',
  investigacao: 'Em investigação',
  qualificada: 'Qualificada',
  contato_identificado: 'Contato identificado',
  contato_iniciado: 'Contato iniciado',
  relacionamento: 'Relacionamento',
  oportunidade_comercial: 'Oportunidade comercial',
  proposta: 'Proposta',
  convertida_crm: 'Convertida para CRM',
  ganha: 'Ganha',
  perdida: 'Perdida',
  monitorar: 'Monitorar',
  descartada: 'Descartada',
};

export const STATUS_FLOW: string[] = [
  'detectada',
  'triagem',
  'investigacao',
  'qualificada',
  'contato_identificado',
  'contato_iniciado',
  'relacionamento',
  'oportunidade_comercial',
  'proposta',
  'convertida_crm',
  'ganha',
  'perdida',
  'monitorar',
  'descartada',
];

// Mapeamento de status legados para o novo fluxo (o radar antigo usava novo/descartado/convertido).
export const LEGACY_STATUS_MAP: Record<string, string> = {
  novo: 'detectada',
  descartado: 'descartada',
  convertido: 'convertida_crm',
};

export const MOTIVO_DESCARTE_LABELS: Record<string, string> = {
  ticket_baixo: 'Ticket baixo',
  margem_insuficiente: 'Margem insuficiente',
  fora_portfolio: 'Fora do portfólio',
  preco_puro: 'Preço puro',
  concorrencia_excessiva: 'Concorrência excessiva',
  informacao_falsa: 'Informação falsa',
  projeto_cancelado: 'Projeto cancelado',
  prazo_inviavel: 'Prazo inviável',
  distancia_logistica: 'Distância / logística',
  capital_alto: 'Capital necessário alto',
  relacionamento_bloqueado: 'Relacionamento bloqueado',
  outro: 'Outro',
};

export const FONTE_LABELS: Record<string, string> = {
  manual: 'Manual',
  google: 'Google',
  noticia: 'Notícia',
  cau: 'CAU',
  crea: 'CREA',
  pncp: 'PNCP',
  diario_oficial: 'Diário Oficial',
  portal_publico: 'Portal público',
  arquiteto: 'Arquiteto',
  construtora: 'Construtora',
  cliente: 'Cliente',
  indicacao: 'Indicação',
  evento: 'Evento',
  networking: 'Networking',
  instagram: 'Instagram',
  linkedin: 'LinkedIn',
  site_empresa: 'Site da empresa',
  outra: 'Outra',
};

// Tipos de fonte do catálogo de origens de inteligência comercial (módulo Fontes).
export const FONTE_TIPOS: { key: string; label: string }[] = [
  { key: 'manual', label: 'Manual' },
  { key: 'google', label: 'Google' },
  { key: 'noticia', label: 'Notícia' },
  { key: 'site_empresa', label: 'Site empresarial' },
  { key: 'cau', label: 'CAU' },
  { key: 'crea', label: 'CREA' },
  { key: 'pncp', label: 'PNCP' },
  { key: 'diario_oficial', label: 'Diário Oficial' },
  { key: 'portal_publico', label: 'Portal público' },
  { key: 'arquiteto', label: 'Arquiteto' },
  { key: 'construtora', label: 'Construtora' },
  { key: 'cliente', label: 'Cliente' },
  { key: 'indicacao', label: 'Indicação' },
  { key: 'evento', label: 'Evento' },
  { key: 'networking', label: 'Networking' },
  { key: 'instagram', label: 'Instagram' },
  { key: 'linkedin', label: 'LinkedIn' },
  { key: 'sistema_licitacoes', label: 'Sistema de licitações' },
  { key: 'outra', label: 'Outra' },
];

export const FONTE_TIPO_LABELS: Record<string, string> = Object.fromEntries(
  FONTE_TIPOS.map((t) => [t.key, t.label]),
);

export interface Fonte {
  id: number;
  nome: string;
  tipo: string;
  url: string | null;
  observacao: string | null;
  status: string;
  created_at: string;
  qtd_obras: number;
  qtd_oportunidades: number;
  valor_obras: number;
  valor_potencial_hop: number;
  lucro_potencial_hop: number;
  quentes: number;
  ultima_ocorrencia: string | null;
}

export interface FonteVinculo {
  id?: number;
  fonte_id: number | null;
  fonte_nome: string | null;
  fonte_tipo: string | null;
  papel: string;
  url_especifica: string | null;
  observacao: string | null;
  data_captura: string | null;
}

export const REGIOES: { key: string; label: string; prioridade: number }[] = [
  { key: 'caruaru_agreste', label: 'Caruaru / Agreste', prioridade: 1 },
  { key: 'recife_rm', label: 'Recife / Região Metropolitana', prioridade: 2 },
  { key: 'pernambuco', label: 'Pernambuco', prioridade: 3 },
  { key: 'paraiba', label: 'Paraíba', prioridade: 4 },
  { key: 'alagoas', label: 'Alagoas', prioridade: 5 },
  { key: 'nordeste', label: 'Nordeste', prioridade: 6 },
  { key: 'outra', label: 'Outra', prioridade: 99 },
];

export const REGIAO_LABELS: Record<string, string> = Object.fromEntries(
  REGIOES.map((r) => [r.key, r.label]),
);

export const CONFIANCA_LABELS: Record<string, string> = {
  baixa: 'Baixa',
  media: 'Média',
  alta: 'Alta',
  confirmada: 'Confirmada',
};

export const PAPEL_FONTE_LABELS: Record<string, string> = {
  origem_principal: 'Origem principal',
  confirmacao: 'Confirmação',
  referencia: 'Referência',
  enriquecimento: 'Enriquecimento',
  outro: 'Outro',
};

export const PAPEL_RADAR_LABELS: Record<string, string> = {
  empresa_alvo: 'Empresa-alvo',
  cliente_final: 'Cliente final',
  contratante: 'Contratante',
  construtora: 'Construtora',
  arquitetura: 'Arquitetura',
  incorporadora: 'Incorporadora',
  projetista: 'Projetista',
  parceiro: 'Parceiro',
  influenciador: 'Influenciador',
  concorrente: 'Concorrente',
  outro: 'Outro',
};

// Pesos do HOP Radar Score (total = 100). Alteráveis futuramente.
export const SCORE_WEIGHTS: { key: string; label: string; max: number }[] = [
  { key: 'potencial_financeiro', label: 'Potencial financeiro', max: 25 },
  { key: 'fit_hop', label: 'Fit com a HOP', max: 20 },
  { key: 'timing', label: 'Timing', max: 15 },
  { key: 'acesso_relacionamento', label: 'Acesso / Relacionamento', max: 15 },
  { key: 'qualidade_info', label: 'Qualidade da informação', max: 10 },
  { key: 'diferenciacao', label: 'Diferenciação', max: 10 },
  { key: 'esforco_risco', label: 'Esforço / Risco', max: 5 },
];

export const SCORE_FATOR_LABELS: Record<string, string> = Object.fromEntries(
  SCORE_WEIGHTS.map((w) => [w.key, w.label]),
);

export function scoreTone(score: number): { label: string; icon: string; tone: string } {
  if (score >= 85) return { label: 'AGIR AGORA', icon: 'ri-fire-fill', tone: 'bg-red-50 text-red-600 border-red-200' };
  if (score >= 70) return { label: 'PRIORIDADE', icon: 'ri-arrow-up-circle-fill', tone: 'bg-green-50 text-green-700 border-green-200' };
  if (score >= 50) return { label: 'MONITORAR', icon: 'ri-time-fill', tone: 'bg-amber-50 text-amber-700 border-amber-200' };
  return { label: 'BAIXA PRIORIDADE', icon: 'ri-record-circle-line', tone: 'bg-gray-100 text-gray-500 border-gray-200' };
}

export function motorDe(valor: number | null | undefined): { key: string; label: string } {
  const v = Number(valor ?? 0);
  if (v >= 200000) return { key: 'grandes_projetos', label: 'Motor Grandes Projetos' };
  return { key: 'caixa', label: 'Motor Caixa' };
}

export interface RadarOportunidade {
  id: number;
  titulo: string;
  empresa: string | null;
  cidade: string | null;
  uf: string | null;
  segmento: string | null;
  descricao: string | null;
  fonte: string | null;
  url_fonte: string | null;
  valor_estimado: number | null;
  score: number | null;
  status: string;
  empresa_id: number | null;
  created_at: string;
  rank: number | null;
  categoria: string | null;
  tipo: string | null;
  regiao: string | null;
  data_descoberta: string | null;
  estagio_projeto: string | null;
  previsao_execucao: string | null;
  previsao_compra: string | null;
  valor_obra: number | null;
  valor_contrato_cau: number | null;
  valor_potencial_hop: number | null;
  custo_estimado: number | null;
  lucro_potencial: number | null;
  margem_estimada: number | null;
  solucoes: string[] | null;
  responsavel: string | null;
  proxima_acao: string | null;
  proxima_acao_em: string | null;
  observacoes: string | null;
  confianca: string | null;
  hop_score: number | null;
  score_fatores: Record<string, { pontos: number; max: number; motivo: string }> | null;
  motivo_descarte: string | null;
  crm_oportunidade_id: number | null;
  obra_id: number | null;
  procedencia: { origem: string; obra_id: number; rrt_numero: string | null; campos: Record<string, string> } | null;
  fontes?: FonteVinculo[];
  motor?: { key: string; label: string };
  relacionadas_count?: number;
}

export function formatBRL(value: number | null | undefined): string {
  if (value == null || value === 0) return '—';
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
}